<mat-accordion multi="true">
  @for (area of _tree; track area) {
    <div>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>{{area.text}}</mat-expansion-panel-header>
        <mat-accordion multi="true">
          @for (group of area.nodes; track group) {
            <div>
              <!--          <mat-expansion-panel expanded="true">
              <mat-expansion-panel-header>{{group.text}}</mat-expansion-panel-header> -->
              <div class="header">{{group.text}}</div>
              <mat-list>
                @for (item of group.values; track item) {
                  <div>
                    <mat-list-item class="node-list-item">
                      <div class="itemcaption">{{item.caption}}</div>
                      <div class="itemvalue">{{item.value}}</div>
                    </mat-list-item>
                  </div>
                }
              </mat-list>
            <!--  </mat-expansion-panel> -->
          </div>
        }
      </mat-accordion>
    </mat-expansion-panel>
  </div>
}
</mat-accordion>
